import {
  HomeIcon,
  UsersIcon,
  BookOpenIcon,
  QuestionMarkCircleIcon,
  ClipboardDocumentListIcon,
  ChartBarIcon,
  CogIcon,
  UserIcon,
  AcademicCapIcon,
  NewspaperIcon,
  ArrowRightStartOnRectangleIcon
} from '@heroicons/react/24/outline'
import { Link, useLocation } from 'react-router-dom'
import { useAuth } from '../../hooks/useAuth'

interface SidebarProps {
  mobile?: boolean
  onItemClick?: () => void
}

const navigation = [
  { name: 'Dashboard', href: '/dashboard', icon: HomeIcon, roles: ['admin', 'professor'] },
  { name: 'Simulados', href: '/simulado', icon: HomeIcon, roles: ['aluno'] },
  { name: 'Turmas', href: '/turmas', icon: UsersIcon, roles: ['admin', 'professor'] },
  { name: 'Usuários', href: '/users', icon: UserIcon, roles: ['admin'] },
  { name: 'Aulas', href: '/aulas', icon: BookOpenIcon, roles: ['admin', 'professor'] },
  { name: 'Questões', href: '/questoes', icon: QuestionMarkCircleIcon, roles: ['admin', 'professor'] },
  { name: 'Testes', href: '/testes', icon: ClipboardDocumentListIcon, roles: ['admin', 'professor'] },
  { name: 'Notícias', href: '/noticias', icon: NewspaperIcon, roles: ['admin'] },
  { name: 'Relatórios', href: '/relatorios', icon: ChartBarIcon, roles: ['admin', 'professor'] },
  { name: 'Configurações', href: '/configuracoes', icon: CogIcon, roles: ['admin'] },
  { name: 'Minhas Aulas', href: '/minhas-aulas', icon: AcademicCapIcon, roles: ['aluno'] },
  { name: 'Perfil', href: '/perfil', icon: UserIcon, roles: ['admin', 'professor', 'aluno'] }
]

function classNames(...classes: string[]) {
  return classes.filter(Boolean).join(' ')
}

const Sidebar = ({ mobile, onItemClick }: SidebarProps) => {
  const { profile, signOut } = useAuth()
  const location = useLocation()

  // Filter navigation items based on user role
  const filteredNavigation = navigation.filter(item =>
    item.roles.includes(profile?.role || '')
  )

  return (
    <div className={`flex grow flex-col gap-y-5 overflow-y-auto ${!mobile ? 'bg-white px-6 pb-4 border-r border-gray-200' : ''}`}>
      <div className="flex h-16 shrink-0 items-center">
        <img
          className="h-8 w-auto"
          src="https://kufrgfjlfhdinewzkwzg.supabase.co/storage/v1/object/public/site/logo.png"
          alt="Bizu"
        />
      </div>
      <nav className="flex flex-1 flex-col">
        <ul role="list" className="flex flex-1 flex-col gap-y-7">
          <li>
            <ul role="list" className="-mx-2 space-y-1">
              {filteredNavigation.map((item) => (
                <li key={item.name}>
                  <Link
                    to={item.href}
                    onClick={onItemClick}
                    className={classNames(
                      location.pathname === item.href
                        ? 'bg-primary-50 text-primary-600'
                        : 'text-gray-700 hover:text-primary-600 hover:bg-primary-50',
                      'group flex gap-x-3 rounded-md p-2 text-sm leading-6 font-semibold'
                    )}
                  >
                    <item.icon
                      className={classNames(
                        location.pathname === item.href ? 'text-primary-600' : 'text-gray-400 group-hover:text-primary-600',
                        'h-6 w-6 shrink-0'
                      )}
                      aria-hidden="true"
                    />
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </li>

          <li className="mt-auto">
            <button
              onClick={() => {
                if (onItemClick) onItemClick()
                signOut()
              }}
              className="group -mx-2 flex gap-x-3 rounded-md p-2 text-sm leading-6 font-semibold text-gray-700 hover:bg-primary-50 hover:text-primary-600 w-full"
            >
              <ArrowRightStartOnRectangleIcon
                className="h-6 w-6 shrink-0 text-gray-400 group-hover:text-primary-600"
                aria-hidden="true"
              />
              Sair
            </button>
          </li>
        </ul>
      </nav>
    </div>
  )
}

export default Sidebar